function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// src/extend-theme.ts
import { theme, baseTheme, isChakraTheme } from "@chakra-ui/theme";
import mergeWith from "lodash.mergewith";

function isFunction(value) {
  return typeof value === "function";
}

function pipe() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (v) {
    return fns.reduce(function (a, b) {
      return b(a);
    }, v);
  };
}

var createExtendTheme = function createExtendTheme(theme2) {
  return function extendTheme2() {
    for (var _len2 = arguments.length, extensions = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      extensions[_key2] = arguments[_key2];
    }

    var overrides = [].concat(extensions);
    var activeTheme = extensions[extensions.length - 1];

    if (isChakraTheme(activeTheme) && // this ensures backward compatibility
    // previously only `extendTheme(override, activeTheme?)` was allowed
    overrides.length > 1) {
      overrides = overrides.slice(0, overrides.length - 1);
    } else {
      activeTheme = theme2;
    }

    return pipe.apply(void 0, _toConsumableArray(overrides.map(function (extension) {
      return function (prevTheme) {
        return isFunction(extension) ? extension(prevTheme) : mergeThemeOverride(prevTheme, extension);
      };
    })))(activeTheme);
  };
};

var extendTheme = createExtendTheme(theme);
var extendBaseTheme = createExtendTheme(baseTheme);

function mergeThemeOverride() {
  for (var _len3 = arguments.length, overrides = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    overrides[_key3] = arguments[_key3];
  }

  return mergeWith.apply(void 0, [{}].concat(overrides, [mergeThemeCustomizer]));
}

function mergeThemeCustomizer(source, override, key, object) {
  if ((isFunction(source) || isFunction(override)) && Object.prototype.hasOwnProperty.call(object, key)) {
    return function () {
      var sourceValue = isFunction(source) ? source.apply(void 0, arguments) : source;
      var overrideValue = isFunction(override) ? override.apply(void 0, arguments) : override;
      return mergeWith({}, sourceValue, overrideValue, mergeThemeCustomizer);
    };
  }

  return void 0;
}

export { extendTheme, extendBaseTheme, mergeThemeOverride };